import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { AutoBookHistory } from "@app/models/rest/auto-book-history";
import { AutoBookHistoryRestService } from "@app/services/hal/auto-book-history-rest.service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class AutoBookHistoryStore extends RealTimeDataStore<AutoBookHistory> {
  constructor() {
    const autoBookHistoryRestService = inject(AutoBookHistoryRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(
      autoBookHistoryRestService,
      webStompSubscriber,
      hateoasResourceService
    );
    super.subscribeToMessaging("AutoBookHistory");
  }
}
